import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { createMigrate, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import { SettingsReducer } from './reducers/settings'

const reducer = combineReducers({
  settings: SettingsReducer,
})

const migrations = {}

const persistedReducer = persistReducer(
  {
    key: 'root',
    storage,
    version: 3,
    migrate: createMigrate(migrations, { debug: false }),
    blacklist: ['workOrderSearch'],
  },
  reducer,
)

const _makeStore = () =>
  configureStore({
    middleware: getDefaultMiddleware => getDefaultMiddleware({ serializableCheck: false }),
    reducer: persistedReducer,
  })

let store: ReturnType<typeof _makeStore>

export const makeStore = () => {
  if (store) return store

  const newStore = _makeStore()
  store = newStore

  return newStore
}

export type RootState = ReturnType<ReturnType<typeof makeStore>['getState']>

export type AppDispatch = ReturnType<typeof makeStore>['dispatch']
